import Vue from "vue";
import axios from "axios";

Vue.mixin({
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    // async getUsers () {
    //   let res = await axios.get("https://reqres.in/api/users?page=1");
    //   let { data } = res.data;
    //   this.setState({ users: data });
    // },

    async fetchData() {
      const res = await fetch("http://172.16.9.20:85/authen/signin.php/");
      let data = await res.json();
      return data;
    },

    async getUserPublic() {
      const res = await fetch(
        this.$apiFix +
          "master.php/UserAccessData345?uid=" +
          this.$store.getters.uid
      );
      let data = await res.json();
      this.$apiUser = data;
      return data;
    },

    getWidthColumn() {
      console.log(this.$q.screen.width);
      if (this.$q.screen.width < 1600) {
        return "display:block;width:280px;white-space:nowrap;border:0px solid red;";
      } else {
        return "display:block;width:600px;white-space:nowrap;border:0px solid red;";
      }
    },

    CheckLocal() {
      this.fetchData()
        .then(data => {
          this.$api = "http://172.16.9.20:85/nygcontrolroom/";
          // this.$api = 'http://127.0.0.1:9000/nygcontrolroom/'

          this.$apiAuthen = "http://172.16.9.20:85/authen/";
          // console.log(this.$api);
          // console.log(this.$apiAuthen);
        })
        .catch(err => {
          this.$api = "https://webalert.nanyangtextile.com/nygcontrolroom/";
          // this.$api = 'http://127.0.0.1:9000/nygcontrolroom/'

          this.$apiAuthen = "https://webalert.nanyangtextile.com/authen/";
          // console.log(this.$api);
          // console.log(this.$apiAuthen);
        });
    },

    getLoad() {
      // let ret = '100'
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "Page07.php/curdate",
        data: params
      }).then(res => {
        // console.log(res.data.dte)
      });

      return obj;
    },

    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },

    async gettime() {
      let res = await axios.get(`${this.$apiflask}/api/board2/gettime`);
      return res.data.time;
      console.log(res.data);
    },

    async keeploc(pagename, loc) {
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: pagename,
          loc: loc,
        },
      };

      await axios({
        method: "post",
        url: `${this.$apiflask}/log/keeploc`, // php
        data: postjson,
      }).then((res) => {

      });
    },

    async keeplocarray1(pagename, loc) {
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: pagename,
          loc: loc,
        },
      };

      await axios({
        method: "post",
        url: `${this.$apiflask}/log/keeplocarray`, // php
        data: postjson,
      }).then((res) => {

      });
    },

    chkAuthen(uid, uuid) {
      let params = new FormData();
      params.append("uid", this.$store.getters.uid);
      params.append("uuid", this.$store.getters.uuid);
      params.append("syscode", "CTRNYG");
      axios({
        method: "post",
        url: this.$apiAuthen + "signin.php/chksession",
        data: params
      }).then(res => {
        try {
          if (res.data.authen == false) {
            this.$router.replace({
              name: "signin"
            });
          }
        } catch (err) {
          this.$router.replace({
            name: "signin"
          });
        }
      });
    },

    chkAuthen1(uid, time) {
      let params = new FormData();
      let date = "";
      params.append("loc", this.location.value);

      axios({
        method: "post",
        url: this.$api + "master.php/curdate",
        data: params
      }).then(res => {
        date = res.data.dte;

        try {
          if (date != this.$store.getters.time) {
            this.$router.replace({
              name: "signin"
            });
          }
        } catch (err) {
          this.$router.replace({
            name: "signin"
          });
        }
      });
    },

    fontsize() {
      if (this.$q.screen.width < 1400) {
        return "font-size: 14px;";
      } else {
        return "font-size: 18px;";
      }
    },

    fontsizeHead() {
      if (this.$q.screen.width < 1400) {
        return "font-size: 16px;";
      } else {
        return "font-size: 20px;";
      }
    }

    // chkSignin () {
    //   let params = new FormData();
    //   axios({
    //     method: "post",
    //     url: this.$api2 + "Signin.asmx/getTime",
    //     data: params
    //   }).then(res => {
    //     console.log('Check Time Signin ' + res.data.chkdate)
    //     let chkDate = res.data.chkdate
    //     try {
    //       if (chkDate != this.$store.getters.adminBackOffice.lastSignIn) {
    //         this.$router.replace({
    //           name: "SigninAdmin"
    //         })
    //       }
    //     } catch (err) {
    //       this.$router.replace({
    //         name: "SigninAdmin"
    //       })
    //     }
    //   })
    // }
  }
});
